import type { MouseEventHandler } from 'react';

import { checkAcl } from '@flow/libs/utils/acl';
import { MenuItem } from '@app/components/menu-item';
import MoveContractModal from '@app/components/modals/move-contract';
import MoveTo from '@app/components/icons/move-to';
import { T } from '@app/components/translation';

export type Props = {
  agreement: Oneflow.Agreement;
  canPerformAction: boolean;
  disabled?: boolean;
  onSuccess?: () => void;
  queryName?: string;
};

const MoveContract = ({ agreement, canPerformAction, disabled, onSuccess, queryName }: Props) => {
  const renderMenuText = () => (
    <T
      _str="Move to..."
      _comment="Menu option to open the move to modal."
    />
  );

  return (
    <MoveContractModal
      agreement={agreement}
      onSuccess={onSuccess}
      queryName={queryName}
    >
      {(onClick: MouseEventHandler) => (
        <MenuItem
          disabled={
            (!canPerformAction && !checkAcl(agreement.acl, 'agreement:move')) || Boolean(disabled)
          }
          label={renderMenuText()}
          onClick={onClick}
          icon={MoveTo}
        />
      )}
    </MoveContractModal>
  );
};

export default MoveContract;
